import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonSvg } from '../Svg';
import { chameleonSplitButton } from './SplitButton.definition';
import { chameleonPopoverV2 } from '../PopoverV2/PopoverV2.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonSplitButton({ prefix }), chameleonPopoverV2({ prefix }), chameleonSvg({ prefix }));
}
